import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import axios, { AxiosRequestHeaders } from "axios";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";

const SkillsAdd: FC = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [pendingValues, setPendingValues] = useState<any>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const headers: AxiosRequestHeaders = {
    "x-access-token": localStorage.getItem("jwttoken") || "",
  };

  const callApiSkillsAdd = async (values: any) => {
    try {
      const url = process.env.REACT_APP_API_URL + "skills/createskill";
      const response = await axios.post(url, values, {headers});
      return response.status === 201 ? { error: false } : { error: true };
    } catch (error) {
      console.error("Error adding skills:", error);
      return { error: true };
    }
  };

  const handleAddConfirmation = async (isConfirmed: boolean) => {
    setModalShow(false);
    if (isConfirmed && pendingValues) {
      const { error } = await callApiSkillsAdd(pendingValues);
      if (!error) {
        setSuccessMessage("Skill added successfully!");
        setShowSuccessModal(true);
        setTimeout(() => {
          navigate("/skills");
        }, 3000);
      } else {
        setFailureMessage("Failed to add skill. Please try again.");
        setShowFailureModal(true);
      }
    }
  };

  return (
    <Container className="mt-5">
      <ConfirmationModal
        show={modalShow}
        modalMessage={modalMessage}
        onHide={() => setModalShow(false)}
        confirmation={handleAddConfirmation}
        operationType="Confirm"
      />

      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />

      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />

      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Add Skills</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  skill_name: "",
                  skill_category: "",
                  skill_tag: "",
                  skill_shortname: "",
                  isactive: "",
                }}
                onSubmit={(values) => {
                  setPendingValues(values);
                  setModalMessage("Are you sure you want to add this skill?");
                  setModalShow(true);
                }}
              >
                {({ values }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="skill_name" className="form-label">
                          Skill Name:
                        </label>
                        <Field
                          name="skill_name"
                          type="text"
                          className="form-control"
                          placeholder="Enter Skill Name"
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="skill_category" className="form-label">
                          Skill Category:
                        </label>
                        <Field
                          name="skill_category"
                          type="text"
                          className="form-control"
                          placeholder="Enter Skill Category"
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="skill_tag" className="form-label">
                          Skill Tag:
                        </label>
                        <Field
                          name="skill_tag"
                          type="text"
                          className="form-control"
                          placeholder="Enter Skill Tag"
                          required
                        />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="skill_shortname" className="form-label">
                          Skill Shortname:
                        </label>
                        <Field
                          name="skill_shortname"
                          type="text"
                          className="form-control"
                          placeholder="Enter Skill Shortname"
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success">
                          Add Skill
                        </Button>
                        <Button
                          variant="danger"
                          className="mx-2"
                          onClick={() => navigate("/skills")}
                        >
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SkillsAdd;
